import React from "react";
import {generateConfigData, generateInfoCard, generate} from "Common/utility/infoCard"




export default class  extends React.Component {


  _generateCard(config, index) {
    const el = generate(config, this.props.location, this.props.type);
    const list_items = Array.from(config.querySelectorAll("item")).map((item, index) => {
      return <li className="pubhub-hackit-card-list-item" key={index}>{item.innerText.trim()}</li>
    });

    const list = <div className="pubhub-hackit-card-list">
      <ul className="pubhub-hackit-card-list-items">{list_items}</ul>
    </div>;


    return (

      <div className="col-md-6 col-sm-12" key={index}>
        <div className="pubhub-hackit-card">
          <div className="row">
            <div className="col">
              {el.title}
              {el.image}
              {el.subtitle}
              {el.description}
              {list}
              {el.link}
            </div>
          </div>
        </div>
      </div>

    )


  }


  render() {
    const {config, location, type} = this.props;

    if (!config) {
      return <span>Loading</span>
    }


    // root info
    const data = generateConfigData(config);
    const elements = generateInfoCard(data, location, this.props.type);

    // two card

    var cards = Array.from(config.querySelectorAll("items > item")).map((item, index) => this._generateCard(item, index));


    return (
      <div className="pubhub-hackit  pubhub-widget" style={elements.imageStyle} id={this.props.id}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col">
              <h1>
                {elements.title}
              </h1>
            </div>
          </div>

          <div className="row">
            {cards}
          </div>

        </div>
      </div>
    );
  }
}
